import { jsonp } from '@ifeng-fe/ui_base';
import { formatImage, formatUrl } from '@ifeng-fe/public_method';

// apiUrl为webpack注入的全局变量
/* eslint-disable */
let apiBaseUrl = apiUrl;

/* eslint-enable */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

// 获取文章评论数
export const getCommentCounts = async docUrl => {
    let data = [];

    try {
        data = await jsonp('//comment.ifeng.com/get/multicount', {
            data: {
                doc_url: docUrl.join('|'),
                format: 'js',
                callback: 'getCommentCount',
            },
            jsonpCallback: 'getCommentCount',
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }

    return data;
};

/**
 * 获取商讯首页列表数据
 * @param pageSize
 * @param pageNum
 * @returns {Promise<*>}
 */
export const getShangxunList = async (pageSize = 30, pageNum = 1) => {
    const listData = await jsonp(`${apiBaseUrl}/shangxun/shangxunList_v2/${pageNum}/${pageSize}/getShangxunList`, {
        jsonpCallback: 'getShangxunList',
        cache: 120,
    });

    if (!listData.data) {
        return '';
    }

    const listDataByPage = listData.data;

    const feedUrlArr = listDataByPage.map(item => item.commentUrl);

    const commentNumArr = await getCommentCounts(feedUrlArr);

    const data = listDataByPage.map((item, index) => ({
        url: item.base62Id ? `https://canews.ifeng.com/c/${item.base62Id}` : formatUrl(item.url),
        thumbnails:
            item.thumbnails && item.thumbnails.image && item.thumbnails.image.value && item.thumbnails.image.value[0]
                ? formatImage(item.thumbnails.image.value[0].url, 150, 0)
                : '',
        title: item.title || '',
        summary: item.summary || item.title || '',
        newsTime: item.newsTime || '',
        commentUrl: `https://gentie.ifeng.com/view.html?docUrl=${item.commentUrl}&docName=${item.title}&skey=${
            item.skey
        }`,
        commentNum: commentNumArr[index].allcount,
    }));

    return data;
};
